/* eslint-disable  @typescript-eslint/no-explicit-any */
export function showGoBackBtn<T extends Array<any>>(history: T) {
  return history.length > 1;
}
